import { useAsyncFn } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';

import { AuthContext } from '../../contexts/Auth.context';
import { useInAppRedirect } from '../useInAppRedirect/useInAppRedirect.hook';

type UseGoogleSignInReturnType = [
  {
    url?: string;
    error?: Error;
    loading: boolean;
  },
  () => void
];

export const useGoogleSignIn = (): UseGoogleSignInReturnType => {
  const host = useContextSelector(AuthContext, ({ webDomain }) => webDomain);

  const { open } = useInAppRedirect();

  return useAsyncFn(async () => {
    const url = await getAuthorisationURLWithQueryParamsAndSetState({
      providerId: 'google',
      authorisationURL: `${host}/auth/callback/google`,
    });
    open(url);
    return url;
  });
};
